import React from "react";
import "./CommunityMessageInput.css";

const CommunityMessageInput = ({ messageInput, setMessageInput, handleSendMessage }) => {
  return (
    <div className="communityMessageInput">
      <input
        type="text"
        value={messageInput}
        onChange={(e) => setMessageInput(e.target.value)}
        placeholder="Type a message"
        className="communityMessageInput-field"
      />
      <button className="communityMessageInput-button" onClick={handleSendMessage}>
        SEND
      </button>
    </div>
  );
};

export default CommunityMessageInput;
